import styled from "styled-components";

export const Container = styled.div`
  margin: 20px;
  margin-bottom: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.71);
  border-bottom: 1px solid rgba(255, 255, 255, 0.71);
  background-color: #060708;
`;
export const Label = styled.h4`
  color: rgba(255, 255, 255, 0.79);
  margin: 10px;
`;

export const ContainerCV = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  padding-top: 0px;
  background-color: #060708;
`;
export const Icon = styled.img`
  width: 25px;
  height: 25px;
`;
export const Shadow = styled.div`
  background-color: rgba(23, 23, 23, 0.67);
  width: 100%;
  height: 100vh;
  opacity: 0.8;
`;
